<template>
  <v-layout row wrap v-if="is_list_available">
    <v-flex md10 xs4>
    </v-flex>
    <v-flex md2 xs8>
     <v-text-field
        class="mr-3"
        v-model="search"
        :label="$t('rms.search')"
        single-line
        color="primary"
        clear-inner-icon="close"
        @input="getApiData"
        @click:clear="clearSearch"
        hide-details
        clearable
        outline
      ></v-text-field>
    </v-flex>
    <v-flex xs12 >
      <VodList :list="vodList.data" :is_vod="true"></VodList>
    </v-flex>
     <v-flex xs12 v-if="vodList.data && vodList.data.length && total > 1">
      <div class="text-xs-center mb-4">
        <v-pagination
          v-model="page"
          :length="total"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import VodList from '@/components/screener/List';
export default {
  name: 'VodMovies',
  metaInfo() {
    return {
      title: 'Screeners',
    };
  },
  components: {
    VodList,
  },
  computed: {
    ...mapState({
      vodList: (state) => state.screening.vodList,
    }),
    total: function() {
      return this.vodList.last_page;
    },
  },
  data: () => ({
    is_list_available: false,
    page: 1,
    perPage:12,
    search:""
  }),
  watch: {
    vodList() {
      this.is_list_available = true;
    },
    page: {
      handler: 'getApiData',
      deep: true,
    },
  },
  created() {
    this.getApiData();
  },
  methods: {
    clearSearch() {
        this.search = "";
        this.getApiData();
    },
    async getApiData() {
      try {
        await this.$store.dispatch('screening/listVodEvents',{
          page: this.page,
          perPage: this.perPage,
          search: this.search
        });
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
